import { Fragment } from "react";
import { CircleMarker, Polyline, Tooltip } from "react-leaflet";
import { pointColor, pointRadius, hazardDetail } from "@/lib/map";
import { intensity } from "@/lib/hazard";

const PointTip = ({ d }) => {
  const extra = hazardDetail(d);
  const sigma = `${d.deviation_sigma >= 0 ? "+" : ""}${d.deviation_sigma}σ`;
  return (
    <Tooltip direction="top" offset={[0, -6]} className="atlas-tip" opacity={1}>
      <b>{d.region}</b>
      <br />
      {d.value} {d.unit || ""} · {sigma}
      {extra && (
        <>
          <br />
          {extra}
        </>
      )}
      <br />
      <span className="atlas-tip-muted">
        {d.provenance?.source} · {(d.triage_status || "").replace(/_/g, " ")}
      </span>
    </Tooltip>
  );
};

const StormLink = ({ d }) => (
  <Polyline positions={[[d.lat, d.lon], [d.storm_link.lat, d.storm_link.lon]]}
    pathOptions={{ color: "#38BDF8", weight: 1.2, opacity: 0.7, dashArray: "4 6" }}>
    <Tooltip sticky className="atlas-tip" opacity={1}>{d.region} ← {d.storm_link.label} · {d.storm_link.distance_km} km</Tooltip>
  </Polyline>
);

export const MapPoints = ({ points, selectedUid, onPointClick, heatmap }) => {
  return points.map((d) => {
    const color = pointColor(d, selectedUid);
    const selected = d.uid === selectedUid;
    const dim = d.feed?.tier === "monitoring";
    return (
      <Fragment key={`${d.uid}-${heatmap ? "h" : "p"}`}>
      {d.storm_link && !heatmap && !dim && <StormLink d={d} />}
      <CircleMarker
        key={`${d.uid}-${heatmap ? "h" : "p"}`}
        center={[d.lat, d.lon]}
        className={`atlas-pt atlas-pt-${d.uid}${d.triage_status === "unexplained_anomaly" && !heatmap && !dim ? " atlas-marker-hot" : ""}`}
        radius={heatmap ? 14 + intensity(d) * 26 : pointRadius(d)}
        pathOptions={{
          color: heatmap ? color : selected ? "#FFFFFF" : "#05070A",
          weight: heatmap ? 0 : selected ? 3 : 1.5,
          fillColor: color,
          fillOpacity: heatmap ? 0.18 + intensity(d) * 0.3 : dim ? 0.28 : 0.9,
          opacity: dim ? 0.4 : 1,
        }}
        eventHandlers={{ click: () => onPointClick && onPointClick(d) }}
      >
        <PointTip d={d} />
      </CircleMarker>
      </Fragment>
    );
  });
};
